import { Button, Card, CloseButton, Col, Form, Row } from 'react-bootstrap'
import Colors from '../../constants/Colors'
import { useRef, useState } from 'react'
import { PreviewFile } from '../HighlightLottery/components/FormFields/UploadImageField/PreviewFile'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import config from '../../config'
import Cookies from 'js-cookie'
import Swal from 'sweetalert2'
import { getPublicUrl, getUploadImageUrl } from '../../helpers/url'
import { XStack } from '../HighlightLottery/index.style'

const LotterySafe = () => {
  const [imageUrl, setImageUrl] = useState('')
  const [image, setImage] = useState(undefined)
  const [receiverId, setReceiverId] = useState('')
  const imageInputRef = useRef(null)
  const dispatch = useDispatch()

  const handleChangeImage = async (e) => {
    if (e.target.files.length !== 0) {
      const file = e.target.files[0]
      dispatch({ type: 'loading_show' })
      const image = new Image()
      image.src = URL.createObjectURL(file)

      image.onload = async () => {
        try {
          const url = await getUploadImageUrl()
          const imageUrl = getPublicUrl(url)

          const response = await fetch(url, {
            method: 'PUT',
            body: file,
          })

          if (!response.ok) throw new Error('Error uploading image')

          setImageUrl(imageUrl)
          setImage(file)
        } catch (error) {
          console.error(error)
          Swal.fire({
            icon: 'error',
            title: 'ไม่สามารถอัพโหลดได้',
            showCloseButton: true,
          })
          setImageUrl('')
          setImage(undefined)
          imageInputRef.current.value = ''
        } finally {
          dispatch({ type: 'loading_hide' })
        }
      }
    } else {
      setImageUrl('')
      setImage(undefined)
      imageInputRef.current.value = ''
    }
  }

  const handleUploadLottery = async () => {
    dispatch({ type: 'loading_show' })
    try {
      const response = await axios.post(
        `${config.apiAdminGateway}/api/v1/admin/lotterytemp/safe`,
        {
          imageUrl,
          userNo: receiverId,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        },
      )
      const { data } = response

      if (data.status.code !== 0) {
        if (data.status.code === 2000) {
          Swal.fire({
            icon: 'error',
            title: 'ไม่พบรหัสสมาชิก',
            showCloseButton: true,
          })
          return
        } else {
          throw new Error(data.status.description)
        }
      }

      Swal.fire({
        icon: 'success',
        title: 'อัปโหลดสําเร็จ',
        showCloseButton: true,
      })

      setImageUrl('')
      setImage(undefined)
      setReceiverId('')
      imageInputRef.current.value = ''
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'ไม่สามารถอัปโหลดได้',
        showCloseButton: true,
      })
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const handleRemoveImage = () => {
    setImageUrl('')
    setImage(undefined)
    imageInputRef.current.value = ''
  }

  return (
    <Card>
      <Card.Header>
        <Card.Title>ฝากลอตเตอรี่</Card.Title>
      </Card.Header>
      <Card.Body>
        <Form.Group>
          <Row>
            <Col sm={12} md={6} lg={4}>
              <input
                className="form-control my-2"
                style={{ color: Colors.DARK_GREY, textTransform: 'uppercase' }}
                type="text"
                placeholder="รหัสสมาชิกของผู้รับ"
                onChange={(e) => {
                  setReceiverId(e.target.value)
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={4} lg={2}>
              <label>อัปโหลดลอตเตอรี่</label>
              <input
                ref={imageInputRef}
                type="file"
                label="เลือกลอตเตอรี่"
                onChange={handleChangeImage}
                accept="image/jpg,image/jpeg"
              />

              {image && (
                <XStack style={{ gap: 16 }}>
                  <PreviewFile file={image} />
                  <CloseButton
                    onClick={handleRemoveImage}
                    style={{
                      position: 'absolute',
                      top: 64,
                      right: 0,
                      backgroundColor: '#f94687',
                      padding: 8,
                      paddingLeft: 12,
                      paddingRight: 12,
                      borderRadius: 32,
                      color: 'white',
                      opacity: 1,
                    }}
                  />
                </XStack>
              )}
            </Col>
          </Row>
        </Form.Group>
      </Card.Body>
      <Card.Footer>
        <Button
          className="float-right"
          variant="primary"
          disabled={!imageUrl || !receiverId}
          onClick={handleUploadLottery}
        >
          ฝากลอตเตอรี่
        </Button>
      </Card.Footer>
    </Card>
  )
}

export default LotterySafe
